import { MENTION_MARKUP } from '../constants/regex';

export const isMentionValid = mention => Boolean(parseMention(mention));

export const parseMention = mention => {
  const allowedModelTypes = ['user'];
  const [, displayName, , modelTypeWithId] = mention.match(MENTION_MARKUP);

  if (!displayName || !modelTypeWithId) {
    return;
  }

  const [modelType, modelId] = modelTypeWithId.split(':');

  if (!modelType || !modelId || !allowedModelTypes.includes(modelType)) {
    return;
  }

  return { displayName, modelType, modelId };
};

export const getParsedMentionsFromContent = content => {
  const mentions = content.match(MENTION_MARKUP, 'gi');

  return mentions.map(parseMention);
};

export const replaceMentionsInContent = (content, replaceFn) => {
  const mentionRegexp = new RegExp(MENTION_MARKUP, 'gi');

  const matches = content.match(mentionRegexp) || [];

  return matches.reduce((content, mention) => {
    const parsedMention = parseMention(mention);

    return content.replace(
      mention,
      replaceFn ? replaceFn(parsedMention) : parsedMention.displayName
    );
  }, content);
};
